import { render } from "./IpRangesTabStorage.vue?vue&type=template&id=69a7fdd7&scoped=true"
import script from "./IpRangesTabStorage.vue?vue&type=script&lang=js"
export * from "./IpRangesTabStorage.vue?vue&type=script&lang=js"

import "./IpRangesTabStorage.vue?vue&type=style&index=0&id=69a7fdd7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a7fdd7"]])

export default __exports__